import {
    ProfessionRefIds,
    QualificationRef2Ids,
    SpeMentionRefIds,
    SpecialityRef2Ids,
} from '@toktokdoctech/tokapi-client'
import { UserData } from '../../_props'
import { titlesMap } from '../../userFormData'

export const buildCommonFields = (userData: UserData) => {
    const rppsNum = userData.rpps?.length === 11 ? userData.rpps : null
    const adeliNum = userData.rpps?.length === 9 ? userData.rpps : null

    const identity = {
        civility: userData.civility,
        title: userData.title && userData.title !== titlesMap.none.value ? userData.title : null,
        lastName: userData.lastName,
        firstName: userData.firstName,
    }

    const professions: ProfessionRefIds[] = userData.professionId
        ? [{ id: userData.professionId, name: userData.profession }]
        : []

    const qualification: QualificationRef2Ids = userData.qualificationId
        ? { id: userData.qualificationId, name: userData.qualification }
        : null

    const speciality: SpecialityRef2Ids = userData.specialityId
        ? { id: userData.specialityId, name: userData.speciality ?? '' }
        : null

    const speMentions: SpeMentionRefIds[] = (userData.speMentions ?? []).map((m) => ({ id: m.id, name: m.name }))

    return { identity, rppsNum, adeliNum, professions, qualification, speciality, speMentions }
}
